import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CORE_CONFIG, CoreConfig } from '../../core-config';
import { ApplicationWithRoles, WorkspaceWithServices } from '../models';
import { MyAccountV2Client } from './my-account-v2.client';
import { MyAccountClient } from './my-account.client';

@Injectable({
  providedIn: 'root',
})
export class ApplicationsApi {
  public readonly basePath: string;

  constructor(
    private _http: MyAccountClient,
    private _http2: MyAccountV2Client,
    @Inject(CORE_CONFIG) private coreConfig: CoreConfig,
  ) {
    this.basePath = coreConfig.applicationsApiBasePath ?? `/applications/${this.coreConfig.appId}/workspaces`;
  }

  getWorkspaces(): Observable<WorkspaceWithServices[]> {
    return this._http2.get<WorkspaceWithServices[]>(this.basePath);
  }

  getLoginUrl(workspaceHash: string): Observable<string> {
    return this._http2
      .get<{ custom_login_url: string }>(`/workspaces/hash-login-url/${workspaceHash}`)
      .pipe(map(({ custom_login_url }) => custom_login_url));
  }

  getApplicationsWithRoles() {
    return this._http2.get<ApplicationWithRoles[]>(`/applications/workspace-applications`);
  }
}
